import { Component } from '@angular/core';
import { ModalBase } from '@components/modal/modal';
import { IAuditData } from '@interfaces/common.interface';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  templateUrl: 'audit-modal.component.html',
})
export class AuditModalComponent extends ModalBase {
  override recordData: Record<string, any> & IAuditData;
  constructor(override readonly activeModal: NgbActiveModal) {
    super(activeModal);
    this.title = $localize`Audytowanie rekordu`;
  }
}
